import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'sample_cell';
export const useSampleCellTranslation = (): UseTranslationResponse<'entities', typeof keyPrefix> => {
  return useTranslation('entities', { keyPrefix });
};

export const ruRu = ({
  [keyPrefix]: {
    tooltip_empty_sample: 'Проверьте настройки сценария',
    no_data: 'Нет данных',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    tooltip_empty_sample: 'Check the script settings',
    no_data: 'No data',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    tooltip_empty_sample: 'Compruebe la configuración del script',
    no_data: 'Sin datos',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    tooltip_empty_sample: 'Verifique as configurações do script',
    no_data: 'Sem dados',
  },
}) as Record<string, unknown>;
